import { createGlobalStyle } from 'styled-components';

const AutocompleteStyle = createGlobalStyle`
  // Remove "powered by Google"
  .pac-container:after {
    display: none !important;
  }

  .pac-container {
    z-index: 1050 !important; /* Ensure it's on top of other elements */
    background-color: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  }

  .pac-item {
    padding: 10px;
    font-size: 14px;
    cursor: pointer;
  }

  .pac-item:hover {
    background-color: #F5F5F5;
  }

  .pac-item-query {
    font-weight: 500;
  }
`;

export default AutocompleteStyle;
